import { makeApiTypes } from 'sidecar-utility-library'

export const types = {
  // Policy
  ...makeApiTypes('CANCEL_POLICY', 'policy'),
  ...makeApiTypes('FETCH_MEMBER_POLICIES', 'policy'),
  ...makeApiTypes('FETCH_POLICY', 'policy'),
  ...makeApiTypes('FETCH_CANCEL_ESTIMATE', 'policy'),
  ...makeApiTypes('UPDATE_UPCOMING_HOUSEHOLD_POLICY', 'policy'),
  ...makeApiTypes('FETCH_POLICY_DETAILS', 'policy'),

  // Policy docs
  ...makeApiTypes('FETCH_APPLICATION_DOCS', 'policy'),
  ...makeApiTypes('FETCH_POLICY_BENEFIT_DOCS', 'policy'),
  ...makeApiTypes('ESTIMATE_POLICY_DOCS', 'policy'),
  ...makeApiTypes('FETCH_POLICY_DOCS', 'policy'),
  ...makeApiTypes('GENERATE_FINAL_DOCS', 'policy'),
  ...makeApiTypes('RENEW_INDIVIDUAL_APPLICATION_DOC_URL', 'policy'),
  ...makeApiTypes('FETCH_AND_RENEW_UPCOMING_POLICY_DOC_URL', 'policy'),
}

export const initialState = {
  applicationDoc: {
    busy: false,
    error: '',
    entity: {},
  },
  // canceling an EB policy
  cancelPolicy: {
    busy: false,
    error: '',
    estimate: {},
  },
  // policies for the member
  selectedMemberPolicies: {
    busy: false,
    error: null,
    entity: [],
  },
  // this is authed member's policy if they
  // are a non_covered primary it's left blank
  policy: {
    benefits: {},
    busy: false,
    error: '',
    entity: {},
  },
  policyBenefitDoc: {
    busy: false,
    error: '',
    entity: {},
  },
  // this is where we'll put the policies for
  // everyone in the account by member uuid
  policies: {
    busy: false,
    error: '',
    entities: {},
  },
  // This is where we add the parent policy for
  // every member of the account.
  masterPolicy: {
    busy: false,
    error: '',
    entity: {},
  },
  policyDocs: {
    // these two are general policy doc
    // busy and error, for the combined docs
    busy: false,
    error: '',
    // uuid of preview policy that's busy
    previewPolicyBusy: '',
    // stores a list of applicant uuids
    // that have errors or have failed
    previewPolicyErrors: [],
    // this will store individual application
    // and policy docs per applicant/member
    // can also include a upcomingPolicyPreview
    // for cases where a member reapplies and
    // wants to view their upcoming (not final)
    // policy documents
    entities: [],
    // this will store the combined application
    // form and policy docs for all the applicants
    // signing up at checkout time
    combinedDocs: {},
  },
  // instead of fussing around with which policy is
  // the upcoming one or not, if when we fetch a policy,
  // if it is upcoming we'll place it here. Since the only
  // time a member will access it, is if they choose to view
  // the upcoming policy from the coverage page (no need to
  // try and shoehorn it in the polices which is stored by
  // memberUuid and risk confusing the two and showing wrong data)
  upcomingPolicy: {},

  // for individual policy api calls
  policyDetails: {
    busy: false,
    error: '',
    entity: {},
  },
}
